export const teacherDashboardEndpoints = {
  login: '/login',
  oauthLogin: '/login-oauth'
};

export const editorDashboardEndpoints = {
  login: '/users/auth/login'
};
